import { Map, OrderedSet } from 'immutable';

import { getOSName, getBrowserName, getDeviceName, getFrameworkName } from './../../util-platform';
import { TrendsType } from '../../constants';

export const SUMMARY_AGGREGATION_TYPES = [
  {
    name: TrendsType.BROWSER,
    titleParser: getBrowserName,
  },
  {
    name: TrendsType.OS,
    titleParser: getOSName,
  },
  {
    name: TrendsType.DEVICE,
    titleParser: getDeviceName,
  },
  {
    name: TrendsType.FRAMEWORK,
    titleParser: getFrameworkName,
  },
];

export const getInitAggregatedNames = () => (
  Map().withMutations((updated) => {
    SUMMARY_AGGREGATION_TYPES.reduce((map, { name }) => (
      map.set(name, OrderedSet())
    ), updated);
  })
);

export const clearSelectedVersion = (state) => state.set(
  'selectedVersion',
  Map({ title: null, items: [], index: 0 }),
);

export const consolidateMetric = (data, mainKey, errorKey, failKey) => {
  if (!data[mainKey]) {
    return {};
  }

  const metric = Object.entries(data[mainKey]).reduce(
    (obj, [name, count]) => ({ ...obj, [name]: { value: count, error: 0, fail: 0 } }),
    {},
  );

  // data[errorKey] can be undefined
  Object.entries(data[errorKey] || {}).forEach(([name, count]) => {
    if (name in metric) {
      metric[name].error += count;
    }
  });

  // data[failKey] can be undefined
  Object.entries(data[failKey] || {}).forEach(([name, count]) => {
    if (name in metric) {
      metric[name].fail += count;
    }
  });

  return metric;
};

export const aggregatePlatformMetrics = (nameToMetricsMap, nameFn) => (
  Object
    .entries(nameToMetricsMap)
    .reduce((acc, [title, metrics]) => {
      const name = nameFn(title);

      if (!(name in acc)) {
        acc[name] = { value: 0, fail: 0, error: 0, items: [] };
      }

      acc[name].value += metrics.value;
      acc[name].fail += metrics.fail;
      acc[name].error += metrics.error;
      acc[name].items.push({ title, ...metrics });

      return acc;
    }, {})
);

export const parseAggregatedMetrics = (newState, metrics) => {
  SUMMARY_AGGREGATION_TYPES.forEach(({ name, titleParser }) => {
    const consolidatedData = consolidateMetric(metrics, name, `${name}Error`, `${name}Fail`);
    const names = aggregatePlatformMetrics(consolidatedData, titleParser);

    newState.setIn(
      ['aggregatedNames', name],
      OrderedSet(
        Object
          .entries(names)
          .map(([title, aggs]) => ({ title, ...aggs }))
          .sort((item1, item2) => item1.value - item2.value),
      ),
    );
  });
};
